module.exports = __webpack_public_path__ + "static/media/message-icon.14076f4f.svg";